import * as API_CONSTANT from "../constants";

export const getAllEmployer = () =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/employer/get/all`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({}),
  }).then((res) => res.json());

export const createEmployer = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/employer/create`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  })
  .then((res) => res.json())
  .catch((err) => console.error("Failed Fetch Create Employer :", err.message));

export const updateEmployer = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/employer/update`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const getEmployerListNoCoid = () =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/employer/get/no/coid`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({ }),
  }).then((res) => res.json());
